import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AllCommunityModules } from '@ag-grid-community/all-modules';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ButtonRendererComponent } from 'src/common/button-renderer.component';
import { ConfirmationDialogComponent } from 'src/common/confirmation-dialog/confirmation-dialog.component';
import { EditButtonRendererComponent } from 'src/common/edit-button-renderer';
import { USER_ID } from 'src/common/keys';
import { NameRendererComponent } from 'src/common/name-renderer';
import { ViewRendererComponent } from 'src/common/view-renderer';
import { FirebaseService } from 'src/services/firebase.service';
import { LocalstorageService } from 'src/services/localstorage.service';
import { NgxToasterService } from 'src/services/ngx-toaster.service';

@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.css']
})
export class TemplateComponent implements OnInit {
  public columnDefs = [
    {
      headerName: 'Title',
      field: 'title',
      cellRenderer: 'nameRenderer',
      cellRendererParams: {
        onClick: this.openAddDialog.bind(this),
      },
      pinned: 'left',
      width: 250
    },
    // {
    //   headerName: '',
    //   field: '',
    //   resizable: true,
    //   filter: false,
    //   cellRenderer: 'viewRenderer',
    //   cellRendererParams: {
    //     onClick: this.openRemoveGoalDialog.bind(this),
    //   },
    //   width: 80
    // },
    {
      headerName: '',
      field: 'delete',
      resizable: true,
      filter: false,
      cellRenderer: 'deleteButtonRenderer',
      cellRendererParams: {
        onClick: this.openRemoveGoalDialog.bind(this),
      },
      width: 80
    }
  ];
  public gridOptions: any;
  public info: string;
  private gridApi: any;
  public attributeList = [];
  public answerTypeList = [];
  public modules = AllCommunityModules;
  public user: any;
  public businessInfoForm: FormGroup;
  public isEdit = false;
  @ViewChild('Adddialog') dialogAddTemplate: TemplateRef<any>;
  constructor(
    public router: Router,
    public dialog: MatDialog,
    public formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<any>,
    public storage: LocalstorageService,
    public confirmationDialogRef: MatDialogRef<ConfirmationDialogComponent>,
    public spinner: NgxSpinnerService,
    public toastr: NgxToasterService,
    public firebase: FirebaseService) {
    this.gridOptions = {
      frameworkComponents: {
        buttonRenderer: EditButtonRendererComponent,
        deleteButtonRenderer: ButtonRendererComponent,
        nameRenderer: NameRendererComponent,
        viewRenderer: ViewRendererComponent
      },
      pagination: true,
      paginationAutoPageSize: true,
    };
  }
  ngOnInit() {
    this.initializeForm();
    this.firebase.getAllTemplates().subscribe((res: any) => {
      this.attributeList = res.map(e => {
        return {
          ...e.payload.doc.data(),
          id: e.payload.doc.id
        };
      });
    });
    this.getAttributeList();
  }
  public getAttributeList = () => {
    this.answerTypeList = [
      { answerTypeId: 1, name: 'Text' },
      { answerTypeId: 2, name: 'Number' },
      { answerTypeId: 3, name: 'File' },
      { answerTypeId: 4, name: 'Single Select' },
      { answerTypeId: 5, name: 'Multi Select' },
      { answerTypeId: 6, name: 'View' },
    ];
  }
  openRemoveGoalDialog(row: any): void {
    // tslint:disable-next-line: no-use-before-declare
    this.confirmationDialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '500px',
      data: { headerName: row.rowData.title }
    });

    this.confirmationDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.removeItemMaster(row.rowData);
      }
    });
  }
  public removeItemMaster(selectedItem: any) {
    if (selectedItem) {
      const model = {
        ...selectedItem,
        active: false
      };
      this.firebase.DeleteTemplate(selectedItem).then(res => { });
      this.confirmationDialogRef.close();
    }
  }
  public initializeForm = () => {
    this.businessInfoForm = this.formBuilder.group({
      title: [],
      bussinessAttributeId: [],
      answerTypeId: [],
      code: [],
      createdById: [this.storage.get(USER_ID)],
      active: true
    });
  }
  onGridReady(params) {
    this.gridApi = params.api;
    // params.api.sizeColumnsToFit();
  }

  onFilterTextBoxChanged(event) {
    this.gridOptions.api.setQuickFilter(event.target.value);
  }
  onCellClicked($event) {

    this.router.navigate(['addUser'], {
      queryParams: {
        id: btoa($event.data.userId)
      }
    });
  }
  public navigateToRoles = () => {
    this.router.navigate(['Roles']);
  }
  openAddDialog(data, templateRef?: TemplateRef<any>): void {
    if (!data.rowData) {
      data.rowData = {
        title: '',
        fieldList: [
          { name: 'department', type: 1 },
          { name: 'class', type: 1 },
          { name: 'subclass', type: 1 },
          { name: 'productDescription', type: 1 },
          { name: 'posDescription', type: 1 },
          { name: 'upcType', type: 1 },
          { name: 'upc', type: 1 },
          { name: 'brandName', type: 1 },
          { name: 'supplierGLNName', type: 1 },
          { name: 'category', type: 1 },
          { name: 'productCopy', type: 6 },
          { name: 'images', type: 6 },
          { name: 'video', type: 6 },
          { name: 'document', type: 6 },
        ]
      };
    } else {
      this.isEdit = true;
    }
    this.dialogRef = this.dialog.open(this.dialogAddTemplate, { width: '800px', data: data.rowData || {} });
  }
  public onSubmit = (data) => {
    const model = { ...data };
    if (this.isEdit) {
      this.firebase.UpdateTemplate(model).then(res => {
        this.dialogRef.close();
      });
    } else {
      this.firebase.addNewTemplate(model).then(res => {
        this.dialogRef.close();
      });
    }
  }
  public addField = (data) => {
    if (data && data.fieldList) {
      data.fieldList.push({ name: '', type: '' });
    } else {
      data.fieldList = [];
      data.fieldList.push({ name: '', type: '' });
    }
  }
  public addOption = (data) => {
    if (data && data.options) {
      data.options.push({ name: '' });
    } else {
      data.options = [];
      data.options.push({ name: '' });
    }
  }
}
